import React from 'react';
import classes from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../../contexts/kato.context';
import { ISWOT } from '../../../../types/screening.types';
import { getLang } from '../../../../helpers/utils';
import { useUser } from '../../../../contexts/user.context';

const baseClass = 'swot-analysis-tab';
const translationKey = 'screening.swot-analysis';
const swotConfig: {
    key: keyof ISWOT,
    titleColor: string,
    type: 'green' | 'red' | 'orange',
}[] = [
        {
            key: 'strengths',
            titleColor: '#118F84',
            type: 'green',
        },
        {
            key: 'weaknesses',
            titleColor: '#C57979',
            type: 'red',
        },
        {
            key: 'opportunities',
            titleColor: '#D8A602',
            type: 'orange',
        },
        {
            key: 'threats',
            titleColor: '#C57979',
            type: 'red',
        }
    ];

const SwotAnalysisTab = () => {
    const { t } = useTranslation();
    const { swotAnalysis } = useKato().screeningInfo;
    const { isModulePresent } = useUser();

    if (!swotAnalysis) return null;

    return (
        <div className={classes[baseClass]}>
            {swotConfig.map((item) => (isModulePresent(item.key) &&
                <div key={item.key} className={classes[`${baseClass}__item`]} style={{ borderColor: item.titleColor }}>
                    <div className={`${classes[`${baseClass}__header`]} ${classes[`${baseClass}__header--${item.type}`]}`}>
                        <span style={{ color: item.titleColor }} className={classes[`${baseClass}__key`]}>{item.key.toUpperCase()}</span>
                        <span className={classes[`${baseClass}__title`]}>{t(`${translationKey}.${item.key}`)}</span>
                    </div>

                    <div className={classes[`${baseClass}__body`]}>
                        {swotAnalysis[item.key]?.map((swotItem, index) => (
                            <div key={index} className={classes[`${baseClass}__text`]}>
                                {swotItem[`text${getLang()}`]}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default SwotAnalysisTab